module.exports = __webpack_public_path__ + "static/img/general02.723fab27.png";